import { fetchCookie, removeCookie } from "./cookies";

export const validateCurrentToken = (): boolean => {
  const token = fetchCookie("1Q_SPA");
  return !!token;
};

export const clearAuthData = () => {
  removeCookie("1Q_SPA");

  try {
    sessionStorage.removeItem("user");
  } catch (error) {
    console.error("Error clearing session storage:", error);
  }
};
